<template>
  <div class="nav-sub">
    <div v-if="!category" class="loading">
      Loading...
    </div>

    <div v-else-if="Object.keys(categoryMap).length > 0 && !!groupId" class="nav-section">
      <h3 class="nav-title">{{categoryMap[groupId].title}}</h3>
      <ul class="nav-list">
        <li v-for="item in categoryMap[groupId].itemList">
          <router-link v-if="item.groupId != 999" :to="'/'+ lan + '/detail/' + categoryMap[groupId].groupId + '/' + item.id">{{ item.title }}</router-link>
          <router-link v-if="item.groupId == 999" :to="'/'+ lan + '/scene/' + categoryMap[groupId].groupId + '/' + item.id">{{ item.title }}</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  export default {
    name: 'CategoryList',
    props: ['category','groupId'],
    data() {
      return {
        lan: this.$route.params.language
      }
    },
    computed: {
      categoryMap: function() {
        var obj = {};
        this.category.forEach((item)=>{
          obj[item.groupId] = item
        })
        return obj;
      }
    },
  };
</script>


// WEBPACK FOOTER //
// CategoryList.vue?3196a8a4